import type { CSSProperties } from 'react';

type Props = {
  size?: number;
  className?: string;
  style?: CSSProperties;
};

export function DrawerMenuIcon({ size = 22, className, style }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      color="currentColor"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      style={style}
      aria-hidden="true"
    >
      <path d="M4 5L16 5" />
      <path d="M4 12L20 12" />
      <path d="M4 19L12 19" />
    </svg>
  );
}
